"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderActions = void 0;
var _loader = require("./loader.constants");
var _constants = require("../pages/manageyourteam/constants");
var _actionTypes = require("../pages/manageyourteam/actionTypes");
const loaderActions = exports.loaderActions = {
  show,
  hide
};
function show(dispatch) {
  _constants.applicationConstants.apiCallInprogressCount += 1;
  if (dispatch) dispatch(updateApiProgress());
  return {
    type: _constants.applicationConstants.handleProgressAction ? _loader.loaderConstants.START : null
  };
}
function hide(dispatch) {
  _constants.applicationConstants.apiCallInprogressCount -= 1;
  if (dispatch) dispatch(updateApiProgress());
  return {
    type: _constants.applicationConstants.handleProgressAction && _constants.applicationConstants.apiCallInprogressCount == 0 ? _loader.loaderConstants.STOP : null
  };
}
function updateApiProgress() {
  return {
    type: _actionTypes.ActionTypes.UPDATE_API_CALL_PROGRESS,
    payload: _constants.applicationConstants.apiCallInprogressCount
  };
}